import React, { useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import styles from "../styles/auth.module.css";
import { BACKEND_URL } from "../config";

const Register = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const navigate = useNavigate();
    const location = useLocation();
    const [shouldSubscribe, setShouldSubscribe] = useState(false);

    // Vérifier si l'utilisateur arrive de la page premium
    useEffect(() => {
        // Définir le titre de la page
        document.title = "Memory Curve";
        
        const params = new URLSearchParams(location.search);
        setShouldSubscribe(params.get("subscribe") === "premium");
    }, [location]);

    // Valider le mot de passe lors de la saisie
    const validatePassword = (value) => {
        setPassword(value);
        if (value.length > 0 && value.length < 8) {
            setPasswordError("Password must contain at least 8 characters");
        } else {
            setPasswordError("");
        }
    };

    const redirectToStripe = async (userId) => {
        try {
            const currentPath = "/main"; // Redirection future après paiement
            
            const response = await fetch(`${BACKEND_URL}/create-checkout-session`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ 
                    user_id: userId,
                    return_url: currentPath
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to create checkout session");
            }

            const data = await response.json();
            sessionStorage.setItem("payment_pending", "true");
            window.location.href = data.url;
        } catch (error) {
            console.error("Error redirecting to payment:", error);
            navigate("/main"); // En cas d'erreur, rediriger vers main
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Vérifier la longueur du mot de passe avant l'envoi
        if (password.length < 8) {
            setPasswordError("Password must contain at least 8 characters");
            return;
        }
        
        try {
            const response = await fetch(`${BACKEND_URL}/register`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email, password }),
            });

            const data = await response.json();
            console.log(data)
            console.log(data.user_id)

            if (response.ok) {
                // Attendre que l'ID utilisateur soit bien enregistré dans `sessionStorage`
                sessionStorage.setItem("user_id", data.user_id);

                // Vérifier que `sessionStorage` contient bien l'ID avant de continuer
                const userId = sessionStorage.getItem("user_id");
                console.log(userId)

                if (!userId) {
                    alert("Error retrieving user ID. Please try logging in.");
                    navigate("/");
                    return;
                }

                // Met à jour la liste des révisions après l'inscription
                await updateRevisions(userId);

                // Si l'utilisateur vient du bouton Premium, rediriger vers Stripe
                if (shouldSubscribe) {
                    await redirectToStripe(userId);
                } else {
                    // Sinon, rediriger normalement vers Main
                    navigate("/main", { replace: true });
                    window.location.reload();
                }
            } else {
                alert(data.detail);
            }
        } catch (error) {
            console.error("Error during registration:", error);
            alert("An error occurred. Please try again.");
        }
    };

    const updateRevisions = async (userId) => {
        try {
            console.log("Fetching revisions for user:", userId);
            const response = await fetch(`${BACKEND_URL}/user-revisions/${userId}`);
            const data = await response.json();

            if (data.revisions) {
                sessionStorage.setItem("revisions", JSON.stringify(data.revisions)); // Stocker les révisions
                console.log("Revisions updated:", data.revisions);
            }
        } catch (error) {
            console.error("Error updating revisions:", error);
        }
    };

    const handleGoogleRegister = async () => {
        try {
            // Ajouter le paramètre subscribe=premium à l'URL de redirection après Google Auth si nécessaire
            let endpoint = `${BACKEND_URL}/auth/google`;
            if (shouldSubscribe) {
                endpoint += "?subscribe=premium";
            }
            
            const response = await fetch(endpoint);
            const data = await response.json();
            if (data.url) {
                window.location.href = data.url;
            } else {
                alert("Error getting Google authentication URL");
            }
        } catch (error) {
            console.error("Error initiating Google registration:", error);
            alert("An error occurred. Please try again.");
        }
    };

    return (
        <div className={styles.authContainer}>
            <Link to="/" className={styles.backButton}>← Back</Link>
            <h1>Register</h1>
            {shouldSubscribe && (
                <div className={styles.premiumNotice}>
                    You're signing up for Premium access.
                </div>
            )}
            <form onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                    <label>Email:</label>
                    <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                </div>
                <div className={styles.formGroup}>
                    <label>Password:</label>
                    <input 
                        type="password" 
                        value={password} 
                        onChange={(e) => validatePassword(e.target.value)} 
                        required 
                    />
                    {passwordError && <div className={styles.errorMessage}>{passwordError}</div>}
                </div>
                <button type="submit" className={styles.submitButton}>Continue</button>
            </form>

            <div className={styles.divider}>
                <hr />
                <span>or</span>
                <hr />
            </div>

            <div className={styles.googleRegister}>
                <button onClick={handleGoogleRegister} className={styles.googleBtn}>
                    <img src="/g-logo.png" alt="Google logo" className={styles.googleIcon} />
                    <span>Continue with Google</span>
                </button>
            </div>

            <p className={styles.authSwitch}>
                Already have an account? <a href="/login">Login here</a>
            </p>
        </div>
    );
};

export default Register;
